/**
 * Opens the branded workspace help guide in a dedicated browser window (always at top).
 * @param {'platform' | 'tender'} [_context] — reserved for future deep-linking; does not change scroll on open
 */
export function openWorkspaceHelp(_context = 'platform') {
  const base = `${import.meta.env.BASE_URL || '/'}`.replace(/\/?$/, '/');
  const url = `${window.location.origin}${base}help/dhruv-workspace-guide.html`;

  const width = Math.min(1180, window.screen.availWidth - 48);
  const height = Math.min(860, window.screen.availHeight - 48);
  const left = Math.round((window.screen.availWidth - width) / 2);
  const top = Math.round((window.screen.availHeight - height) / 2);
  const features = [
    'noopener',
    'noreferrer',
    `width=${width}`,
    `height=${height}`,
    `left=${left}`,
    `top=${top}`,
    'scrollbars=yes',
    'resizable=yes'
  ].join(',');

  const win = window.open(url, 'dhruv-workspace-help', features);
  if (win) {
    win.focus();
    const resetScroll = () => {
      try {
        win.scrollTo(0, 0);
        if (win.document?.documentElement) win.document.documentElement.scrollTop = 0;
        if (win.document?.body) win.document.body.scrollTop = 0;
      } catch {
        // ignore cross-origin edge cases
      }
    };
    win.addEventListener('load', resetScroll);
    resetScroll();
  }
}

export default openWorkspaceHelp;
